/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GeneratePasswordEndpointResponse
 */
export interface GeneratePasswordEndpointResponse {
    /**
     * 
     * @type {string}
     * @memberof GeneratePasswordEndpointResponse
     */
    password: string;
}

export function GeneratePasswordEndpointResponseFromJSON(json: any): GeneratePasswordEndpointResponse {
    return GeneratePasswordEndpointResponseFromJSONTyped(json, false);
}

export function GeneratePasswordEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeneratePasswordEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': json['password'],
    };
}

export function GeneratePasswordEndpointResponseToJSON(value?: GeneratePasswordEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
    };
}


